export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/number.js
// module id = ../../../../d3-array/src/number.js
// module chunks = 4